import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getConfig = async () => {
  const { data } = await axios.get(`${API}/config`);
  return data;
};

export const createPlan = async (payload) => {
  const { data } = await axios.post(`${API}/plan`, payload);
  return data;
};

export const downloadPdf = async (payload) => {
  const res = await axios.post(`${API}/pdf`, payload, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = "putni-nalog.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
